import * as generalActions from './generalActions'
import * as loginAction from './loginActions'
import * as general from '../constants/General'
import * as systemSetting from '../constants/SystemSettings'
import * as barcodePrefix from '../constants/BarcodePrefix'
import * as actionTypes from '../constants/ActionTypes'

export function barcodeScanned(barcode) {
    return (dispatch, getState) => {
        const state = getState();

        const {
            posId,
            uniqueid,
            systemSettings
        } = state.generalState;

        const {
            barcodePrefix
        } = state.barcodeState;

        const {
            loggedin
        } = state.loginState;

        if (!loggedin.id) {
            //Geen gebruiker ingelogd, dus probeer in te loggen met barcode
            dispatch(loginAction.loginUser({
                PosId: posId,
                Code: barcode,
                UniqueId: uniqueid
            }));
        }
        else {
            const logOffBarcode = systemSettings && systemSettings[systemSetting.KIOSK_LOGOFF_BARCODE];
            if (logOffBarcode && logOffBarcode.trim() === barcode.trim()) {
                dispatch(loginAction.logoutUser());
            }
            else {
                //Activeer filter
                var hasModalOpen = document.querySelectorAll('.customerBaseModal').length > 0 || document.querySelectorAll('.ticketBaseModal').length > 0 || document.querySelectorAll('.inputModal').length > 0;
                if (!hasModalOpen) {
                    dispatch(generalActions.loadingStart());

                    fetch(general.API_URL_BARCODESCANNED, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            PosDeviceGuid: uniqueid,
                            Barcode: `${(barcodePrefix ? barcodePrefix : '')}${barcode}`,
                            UserId: loggedin.id,
                            PosId: posId
                        })
                    }).then(() => {
                        dispatch(generalActions.loadingEnd());
                    });
                }
            }
        }
    }
}

const setBarcodePrefix = barcodePrefix => ({
    type: actionTypes.SET_BARCODE_PREFIX,
    barcodePrefix: barcodePrefix
});

export const setScannerInReservationMode = () => dispatch => dispatch(setBarcodePrefix(barcodePrefix.RESERVATION));
export const setScannerInCustomerMode = () => dispatch => dispatch(setBarcodePrefix(barcodePrefix.CUSTOMER));
export const clearScannerMode = () => dispatch => dispatch(setBarcodePrefix(null));



// WEBPACK FOOTER //
// src/actions/barcodeActions.js